import {appAPI} from "../../../api";
import {
    IBalanceHistoryResponse, IBalanceInfo,
    ICompaniesBalance,
    ICompany,
    IGetBalanceHistoryParams, IUpdateCompanyTariffParams
} from "../../../models/iCompanies";
import {ICreatePaymentRequest, ICreatePaymentResponse, IPaymentStatusResponse} from "../../../models/iPayment";

export const companyPath = `/companies`;
export const balancePath = `/company-balance`;
export const companyTariffPath = `${companyPath}/tariff`;
export const paymentsPath = '/payments/yookassa';

export const companyAPI = {
    getAll: async () => {
        const res = await appAPI.get(companyPath);
        return res.data;
    },
    checkById: async (company_id: string) => {
        const res = await appAPI.get(`${companyPath}/${company_id}`, {});
        return res.data;
    },
    update: async (company: ICompany) => {
        const res = await appAPI.put(companyPath, company);
        return res.data;
    },

    delete: async (companyId: string) => {
        const res = await appAPI.delete(`${companyPath}/${companyId}`);
        return res.data;
    },

    updateBalance: async (balance: ICompaniesBalance) => {
        const res = await appAPI.put(balancePath, balance);
        return res.data;
    },

    getBalanceHistory: async (
        params: IGetBalanceHistoryParams,
        signal?: AbortSignal,
    ): Promise<IBalanceHistoryResponse> => {
        const res = await appAPI.get(`${balancePath}/history`, {
            params,
            // ✅ axios >= 0.22 понимает нативный AbortSignal напрямую
            signal,
        });
        return res.data;
    },
    updateTariff: async (params: IUpdateCompanyTariffParams) => {
        const res = await appAPI.put(companyTariffPath, params);
        return res.data;
    },

    getBalanceInfo: async (): Promise<IBalanceInfo> => {
        const res = await appAPI.get(`${companyPath}/balance-info`);
        return res.data;
    },

    createPayment: async (
        data: ICreatePaymentRequest,
    ): Promise<ICreatePaymentResponse> => {
        const res = await appAPI.post(`${paymentsPath}/create`, data);
        return res.data;
    },

    getPaymentStatus: async (
        paymentId: string,
    ): Promise<IPaymentStatusResponse> => {
        const res = await appAPI.get(`${paymentsPath}/status/${paymentId}`);
        return res.data;
    },
};
